import { api } from './api';

export class ClientService {
  async searchClients(params = {}) {
    return api.get('/clients', { params });
  }

  async getClientById(clientId) {
    return api.get(`/clients/${clientId}`);
  }

  async createClient(data) {
    return api.post('/clients', data);
  }

  async updateClient(clientId, data) {
    return api.put(`/clients/${clientId}`, data);
  }
}

export const clientService = new ClientService();
